// extracted by mini-css-extract-plugin
var _1 = "container--qeoxG";
var _2 = "content--iZSNz";
var _3 = "placeholder--Vhnyk";
export { _1 as "container", _2 as "content", _3 as "placeholder" }
